import React from 'react';

import { Avatar as ChakraAvatar, AvatarProps as ChakraAvatarProps } from '@chakra-ui/react';

export default function Avatar({
  name = 'Tei Fei',
  size = '2xl',
  bg = 'secondary.default',
  ...rest
}:ChakraAvatarProps) {
  return (
    <ChakraAvatar
      name={name}
      color="white"
      bg={bg}
      size={size}
      fontFamily="Nunito-Bold"
      fontWeight={800}
      {...rest}
    />
  );
}
